var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowUpIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.2629 12.1518L10.07 4.55692L2.87715 12.1518L-6.60261e-08 10.6328L10.07 5.11031e-07L20.14 10.6328L17.2629 12.1518Z",
    fill: "#223A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpIos);
export default __webpack_public_path__ + "static/media/ic-arrow-up-ios.108a6175dcce8e64af73f860d2312454.svg";
export { ForwardRef as ReactComponent };